/**
 * Host Configuration - Detects whether running inside Excel or standalone browser
 */

let _isExcelHost = false;

export function setExcelHost(value) {
  _isExcelHost = value;
}

export function isExcelHost() {
  return _isExcelHost;
}
